import Button from "@/components/atom/Button";
import Divider from "@/components/atom/Divider";
import { useMemo, useState } from "react";

export default function TopProduct({ datas = [] }) {
  let isFiveBestSeller = datas?.length > 5;
  const [showAll, setShowAll] = useState(false);
  const isdatas = useMemo(() => {
    return showAll
      ? datas
      : datas.slice(0, isFiveBestSeller ? 5 : datas?.length);
  }, [showAll, datas?.length]);

  return (
    <div>
      <div
        className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8
      flex flex-col gap-3 xs:gap-6
      '>
        <div className='flex flex-col gap-2'>
          <p className='subheading-semiBold text-greyscaleGON-700'>
            Top Produk
          </p>
          <p className='p2-regular sm:p1-regular text-greyscaleGON-400'>
            Menampilkan{" "}
            {showAll ? datas?.length : isFiveBestSeller ? 5 : datas?.length}{" "}
            produk yang paling banyak dibeli
          </p>
        </div>
        <Divider />
        <div className='flex flex-col gap-3 xs:gap-6'>
          {isdatas?.map((item, index) => (
            <div
              key={index}
              className='flex justify-between items-center'>
              <div className='flex items-center gap-3'>
                <p className='p1-medium text-greyscaleGON-700'>{index + 1}</p>
                <p className='p1-medium text-greyscaleGON-700'>
                  {item?.product_name}
                </p>
              </div>
              <div className='flex items-center gap-3'>
                <p className='p1-medium text-greyscaleGON-400'>
                  {item?.sum_product_qty ?? 0} pcs
                </p>
              </div>
            </div>
          ))}
          {isFiveBestSeller && (
            <div>
              <Button
                label={showAll ? "Top 5 Produk" : "Lihat Semua"}
                variants='outline'
                onClick={() => setShowAll(!showAll)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
